import { render, staticRenderFns } from "./SyncEmails.vue?vue&type=template&id=5f05b8c1"
import script from "./SyncEmails.vue?vue&type=script&lang=js"
export * from "./SyncEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports